
import { Component, Prop, Vue } from 'vue-property-decorator'
import TitlePage from '@/components/atoms/TitlePage.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'
import ButtonSubmitSquare from '@/components/molecules/ButtonSubmitSquare.vue'
import ManageSidemenuLayout from '@/components/organisms/layout/ManageSidemenuLayout.vue'
import ProblemList from '@/components/organisms/manage/proofread/ProblemList.vue'
import { ProofreadProblem } from '@/models/manage/ProofreadList'

/**
 * 校正画面-単元一覧
 */
@Component({
  components: {
    TitlePage,
    ImageBase,
    PanelFrame,
    ButtonSubmitSquare,
    ManageSidemenuLayout,
    ProblemList,
  },
})
export default class ProofreadProblems extends Vue {
  /** 塾管理権限の画面か否か */
  @Prop({ default: false })
  private isAcademy!: boolean

  /** システム管理権限の画面か否か(未使用) */
  @Prop({ default: false })
  private isAdmin!: boolean

  /** 問題一覧 */
  @Prop()
  private problemList!: ProofreadProblem[]

  /** 問題選択時の処理 */
  @Prop()
  private eventSelectProblem!: (id: number) => Promise<void>

  /** 戻るボタン押下時の処理 */
  @Prop()
  private eventReturn!: () => Promise<void>
}
